export default __webpack_public_path__ + "f714d1afaf0ff9f047f0ae1fc482bf80.svg";